import { Pipe, PipeTransform } from '@angular/core';
import { formatWsAdminIdDisplay } from './ws-superadmin-copy/ws-superadmin-copy.util';

@Pipe({ name: 'wsAdminIdDisplay' })
export class WsAdminIdDisplayPipe implements PipeTransform {
  transform(value: string | number | null | undefined, truncate = true): string {
    return formatWsAdminIdDisplay(value, truncate);
  }
}
